import wktcrs from "wkt-crs";
import { EPSGInfo } from "./EPSGInfo";
import wkt from 'wkt';
import * as THREE from 'three';
import * as turf from "@turf/turf";
import { message } from "antd";

export const getProjStringFromCrsWkt = (crs: string) => {
    console.log(crs)
    if (!crs.includes("PROJCS")) {
        console.warn("This crs does not have proj string;");
        return "";
    }

    let resultProjString = "PROJCS";
    const temp = crs.split("PROJCS")[1].split("");
    let count = 0;
    for (let i = 0; i < temp.length; i++) {
        const c = temp[i];
        if (c === "[") {
            count++;
        } else if (c === "]") {
            count--;
        }

        resultProjString = `${resultProjString}${c}`;

        if (i > 0 && count === 0) {
            break;
        }
    }
    return resultProjString;
};

export const getProjUnitFromProjString = (projString: string) => {
    if (!projString.includes("PROJECTION")) {
        console.warn("This projString does not have PROJECTION;");
        return "";
    }

    let projUnit = "m";
    const temp = projString.split("PROJECTION")[1].split(`,UNIT["`)[1].split(`",`)[0];
    if (temp.includes("feet") || temp.includes("foot")) {
        projUnit = "ft";
    }
    return projUnit;
};

export const getEPSGDetails = (wkt: string) => {
    try {
        let { data } = wktcrs.parse(wkt);

        // Check COMPD_CS
        if (data.COMPD_CS) {
            data = data.COMPD_CS;
        }

        let epsgData = new EPSGInfo("", "");
        let horizontalCrs = data.PROJCS;

        if (horizontalCrs?.AUTHORITY) {
            epsgData.horizontal = horizontalCrs.AUTHORITY[2]; // EPSG code is the third element in the array
        }

        let verticalCrs = data.VERT_CS;

        if (verticalCrs?.AUTHORITY) {
            epsgData.vertical = verticalCrs.AUTHORITY[2]; // EPSG code is the third element in the array
        }


        return epsgData;
    } catch (error) {
        let errorMessage = "Unable to get projection";
        message.warning(errorMessage);
        return new EPSGInfo("", "");
    }
}

export const convertPointsArrToWkt = (pointsArr: [number, number, number][]) => {
    // convert points to wkt format
    let wkt = "POLYGON ((";
    if (pointsArr.length > 0) {
        pointsArr.forEach((p: [number, number, number],index :number) => {
            wkt += `${p[0]} ${p[1]} ${p[2]}, `;
        });
        wkt += `${pointsArr[0][0]} ${pointsArr[0][1]} ${pointsArr[0][2]}`;

    }
    wkt += "))";
    
    return wkt;
}

export const convertWktToPointsArr = (inWKTString: string) => {
    // convert wkt to points
    let pointsArr = wkt.parse(inWKTString)

    if(!pointsArr) return []

    pointsArr = pointsArr.coordinates[0].map((p: any) => {
        return [p[0], p[1], p[2] || 0];
    });
    return pointsArr;
}

export const getArea = (inPointArr: [number, number][]) => {
    // inPointArr should be not self-intersecting

    let contour = inPointArr.map((p: [number, number]) => {
        return new THREE.Vector2(p[0], p[1]);
    });

    const area = THREE.ShapeUtils.area(contour);
    return Math.abs(area);
}
export const isSelfIntersecting = (polygonArr: [number, number][]) => {
    const poly1 = turf.polygon([polygonArr]);
    const kinks = turf.kinks(poly1);
    return kinks.features.length > 0;
}

